/* unplugin-vue-components disabled */import script from "./AddCarouselConfigureModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddCarouselConfigureModal.vue?vue&type=script&setup=true&lang=js"

import "./AddCarouselConfigureModal.vue?vue&type=style&index=0&id=52e209af&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/wyt-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52e209af"]])

export default __exports__